exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sipsBlock>form{padding-top:0!important}payment-sips .dimmer{position:fixed!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/my-purchase/buy-product/payment-sips/payment-sips.styl
// module id = 941
// module chunks = 0